<div class="login-container page-container m-md">

  <div class="scrollable-content">
    <div class="login-header">
      <img [src]="'logos/app-logo-vertical.png' | envPrefix" [attr.alt]="'app.title' | translate" class="login-logo" width="120"
        height="120" data-testid="login-logo" (mousedown)="onLogoPressStart()" (mouseup)="onLogoPressEnd()"
        (mouseleave)="onLogoPressEnd()" (touchstart)="onLogoPressStart()" (touchend)="onLogoPressEnd()"
        (touchcancel)="onLogoPressEnd()" (contextmenu)="$event.preventDefault()" />
      <h1>{{ appName }}</h1>
      <p>{{ appDescription }}</p>
    </div>

    <p class="login-message">{{ 'auth.login.title' | translate }}</p>

    <ng-template #googleAuthSection>
      <div class="auth-section">
        <button class="google-button" (click)="login()" data-testid="google-login-button">
          <svg class="google-icon" viewBox="0 0 24 24">
            <path fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          {{ 'auth.login.google' | translate }}
        </button>

        <p class="switch-account-hint">
          {{ 'auth.login.switchAccountHint' | translate }}
        </p>
      </div>
    </ng-template>

    @if (enableTestAuth()) {
    <!-- Google is joined by the QA-unlocked test login tab, so the tab strip header is needed -->
    <div class="auth-tabs-panel">
      <app-tab-strip [(selected)]="activeTab">
        <app-tab id="google" label="{{ 'auth.login.googleTab' | translate }}">
          <ng-container [ngTemplateOutlet]="googleAuthSection" />
        </app-tab>

        <app-tab id="test" label="{{ 'auth.login.testTab' | translate }}">
          <div class="auth-section">
            <h3 class="auth-title">{{ 'auth.login.testTitle' | translate }}</h3>
            <p class="auth-description">{{ 'auth.login.testDescription' | translate }}</p>

            <form class="auth-form" (submit)="testLogin(); $event.preventDefault()">
              <app-input>
                <input type="text" [ngModel]="testEmail()" (ngModelChange)="testEmail.set($event)" name="testEmail"
                  placeholder="user1" data-testid="test-email-input" />
              </app-input>
              <button type="submit" class="test-button" [disabled]="!testEmail().trim()" data-testid="test-login-button">
                {{ 'auth.login.testLogin' | translate }}
              </button>
            </form>

            <p class="test-info-text">{{ 'auth.login.testInfo' | translate }}</p>
            <p class="test-hint-text">{{ 'auth.login.testHint' | translate }}</p>
          </div>
        </app-tab>
      </app-tab-strip>
    </div>
    } @else {
    <!-- Google is the only remaining provider — no tab header needed -->
    <ng-container [ngTemplateOutlet]="googleAuthSection" />
    }

    <p class="login-note">
      {{ 'auth.login.terms' | translate }}
    </p>

    <a class="learn-more-link" routerLink="/landing" data-testid="learn-more-link">
      {{ 'auth.login.learnMore' | translate }}
    </a>

  </div>
</div>